import axios from 'axios';
import { useState } from 'react';
import { useAuth } from './../AuthContext';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const UserFeedback = ({ showFeedbackTitle = true }) => {
    const { userData, isLogged } = useAuth();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);

    const handleFeedbackSubmit = async () => {
        if (!message.trim()) {
            alert("Please enter a message.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/sendFeedback.php`, {
                userId: userData.userId,
                name: userData.name,
                email: userData.email,
                message: message,
            });

            if (response.data.success) {
                setSuccess("Thank you for your feedback!");
                setMessage('');
            } else {
                setSuccess("Something went wrong. Please try again.");
            }
        } catch (error) {
            setSuccess("Error sending feedback. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!isLogged || !userData) return null;

    return (
        <div className="feedback-container">
            {showFeedbackTitle &&
                <h2 className="feedback-title">Customer Feedback</h2>}
            <div className="feedback-box">
                <textarea
                    className="feedback-input"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Enter your feedback here..."
                />
                <div className="feedback-actions">
                    <button
                        className="send-feedback-btn"
                        onClick={handleFeedbackSubmit}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send Feedback"}
                    </button>
                </div>
            </div>
            {success && <p className="feedback-success">{success}</p>}
        </div>
    );
};

export default UserFeedback;
